jQuery(document).ready(function ($) {
  // menu-Link (Add class to Menu)
    $('.fancybox-link a').click(function(){
      $target = '#modal-'+(this.href).split('#')[1];
      $.fancybox.open({
        src : $target,
        type : 'inline',
      });
    });
});
